import { useEffect } from 'react';

export default function SessionLost() {
  useEffect(() => {
    window.location.replace('/');
  }, []);

  return <></>;
}
